<template>
  <abstract-graph :show="!!data">
    <v-graph :data="data" :layout="layout" :options="options"/>
  </abstract-graph>
</template>

<script>
import AbstractGraph from './AbstractGraph'
import color from './color'

export default {

  props: {
    label: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    loadDataFn: {
      type: Function,
      required: true
    }
  },

  components: {
    AbstractGraph
  },

  data () {
    return {
      data: [],
      layout: {
        barmode: 'stack',
        title: this.label,
        legend: {
          orientation: 'h',
          x: 0.5,
          xanchor: 'center'
        },
        paper_bgcolor: 'transparent',
        plot_bgcolor: 'transparent',
        yaxis: {
          gridcolor: '#bfbfbf'
        },
        colorway: color,
        xaxis: {
          visible: false
        },
        showTips: true,
        hoverlabel: {
          namelength: -1
        }
      },
      options: { displayModeBar: false, responsive: true }
    }
  },

  created () {
    this.loadData()
  },

  methods: {
    loadData () {
      this.chartData = null
      this.loadDataFn({
        type: this.type
      })
        .then(data => {
          this.data = data
        })
    }
  }
}

</script>
